import { render } from "./Menu.vue?vue&type=template&id=1f54609c"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=1f54609c&lang=scss&rel=stylesheet%2Fscss"
script.render = render

export default script